module.exports = __webpack_public_path__ + "img/sofia-spedaletti.0bf19a1a.png";